/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { CDK_TABLE_TEMPLATE, CdkTable } from '@angular/cdk/table';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export const _MatTable = CdkTable;
/**
 * Wrapper for the CdkTable with Material design styles.
 */
export class MatTable extends _MatTable {
}
MatTable.decorators = [
    { type: Component, args: [{selector: 'mat-table',
                exportAs: 'matTable',
                template: CDK_TABLE_TEMPLATE,
                styles: [".mat-table{display:block}.mat-header-row,.mat-row{display:flex;border-bottom-width:1px;border-bottom-style:solid;align-items:center;min-height:48px;padding:0 24px}.mat-cell,.mat-header-cell{flex:1}"],
                host: {
                    'class': 'mat-table',
                },
                encapsulation: ViewEncapsulation.None,
                preserveWhitespaces: false,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
MatTable.ctorParameters = () => [];
function MatTable_tsickle_Closure_declarations() {
    /** @type {?} */
    MatTable.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatTable.ctorParameters;
}
//# sourceMappingURL=table.js.map